import {
    mainPagePlatformNewsCatalog,
} from "../../../../content/platform-news";

export const featuredNewsItems = mainPagePlatformNewsCatalog.map(
    (newsItem) => ({
        id: newsItem.id,
        ...newsItem.featured,
        url: `/news/${newsItem.slug}`,
        year: newsItem.dateTime.slice(0, 4),
        isExternal: false,
    })
);
